///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
namespace TotalPoll {
    import Controller = TotalCore.Common.Controller;
    import SettingsService = TotalCore.Common.Providers.SettingsService;

    @Controller('controllers.totalpoll')
    export class PreviewCtrl {
        public preview = {
            screen: 'vote',
            currentQuestion: 0,
            checked: {}
        };
        public settings = this.SettingsService.settings;

        constructor(private $scope, private $sce, private SettingsService: SettingsService) {

        }

        escape(content) {
            return this.$sce.trustAsHtml(content);
        }

        getInputType(question) {
            return question.settings.selection.maximum > 1 ? 'checkbox' : 'radio';
        }

        getPercentageWidthFor(question, choice) {
            question.votesOverride = 0;
            angular.forEach(question.choices, (choice) => {
                question.votesOverride += choice.votesOverride || 0;
            });

            return `${(choice.votesOverride / question.votesOverride) * 100}%`;
        }

        getScreen() {
            return this.preview.screen;
        }

        getSlide() {
            return this.preview.currentQuestion;
        }

        hasQuestion(index) {
            return Boolean(this.SettingsService.settings.questions[index]);
        }

        isBackButtonVisible() {
            return this.isScreen('results') && !this.isNextButtonVisible();
        }

        isChoiceSelected(question, choice) {
            return this.preview.checked[question.uid] && this.preview.checked[question.uid].indexOf(choice.uid) != -1;
        }

        isNextButtonVisible() {
            return this.isSlider() && this.hasQuestion(this.getSlide() + 1);
        }

        isPreviousButtonVisible() {
            return this.isSlider() && this.hasQuestion(this.getSlide() - 1);
        }

        isQuestion(index) {
            return this.preview.currentQuestion === index;
        }

        isQuestionVisible(index) {
            if (!this.hasQuestion(this.getSlide())) {
                this.setSlide(0);
            }

            return !this.isSlider() || this.isQuestion(index);
        }

        isResultsButtonVisible() {
            return this.isScreen('vote') && this.SettingsService.settings.results.visibility == 'all' && !this.isNextButtonVisible();
        }

        isScreen(screen) {
            return this.preview.screen === screen;
        }

        isSlider() {
            return this.SettingsService.settings.design.behaviours.slider;
        }

        isVoteButtonVisible() {
            return this.isScreen('vote') && !this.isNextButtonVisible();
        }

        previewBack() {
            this.setSlide(0);
            this.setScreen('vote');
        }

        previewNext() {
            let next = this.getSlide() + 1;

            if (this.hasQuestion(next)) {
                this.setSlide(next);
            }
        }

        previewPrevious() {
            let previous = this.getSlide() - 1;

            if (this.hasQuestion(previous)) {
                this.setSlide(previous);
            }
        }

        previewResults() {
            this.setSlide(0);
            this.setScreen('results');
        }

        previewVote() {
            this.setSlide(0);
            this.setScreen('results');
        }

        setScreen(screen) {
            this.preview.screen = screen;
        }

        setSlide(index) {
            this.preview.currentQuestion = index;
        }

        toggleChoice(question, choice) {
            let multiple = question.settings.selection.maximum > 1;

            if (!this.preview.checked[question.uid]) {
                this.preview.checked[question.uid] = [];
            }

            if (this.isChoiceSelected(question, choice)) {
                this.preview.checked[question.uid].splice(this.preview.checked[question.uid].indexOf(choice.uid), 1);
            } else {
                if (multiple) {
                    this.preview.checked[question.uid].push(choice.uid);
                } else {
                    this.preview.checked[question.uid] = [choice.uid];
                }
            }
        }
    }

}